import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { BetslipConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { ModalDialogService } from '@frontend/sports/modal/feature';
import { CashierService } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { AlertButtonComponent } from 'packages/sports/web/app/src/native-alerts/alert-button/alert-button.component';
import { AlertConfigService } from 'packages/sports/web/app/src/native-alerts/alert-config.service';

import { DepositDetailsComponent } from '../../../../digital/components/betslip-deposit-details.component';
import { IFailedSlipResult, ISucceededSlipPickResult, ISucceededSlipResult } from '../../../betplacement/models';
import { EditBetActions } from '../../../edit-bet/actions';
import { BetslipResultActions } from '../../actions';

@Component({
    selector: 'bs-digital-result-links',
    templateUrl: './result-links.component.html',
    styleUrls: ['./result-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultLinksComponent implements OnInit {
    @Input() shouldShowQuickLinks = false;
    @Input() shouldShowShareMyBet = false;
    @Input() trackingInformation: string;
    @Input() succeededSlips: ISucceededSlipResult[] = [];
    @Input() failedSlips: IFailedSlipResult[] = [];
    @ViewChild(AlertButtonComponent) nativeAlertButton?: AlertButtonComponent;

    depositInfo: SafeHtml;
    private isDepositDetailsAvailable: boolean;
    liveAlert = false;
    picks: ISucceededSlipPickResult[];

    constructor(
        private store: Store,
        private trustPipe: TrustPipe,
        public sitecore: Sitecore,
        private betslipConfig: BetslipConfig,
        private modalDialogService: ModalDialogService,
        private cashierService: CashierService,
        private alertConfigService: AlertConfigService,
    ) {}

    ngOnInit(): void {
        this.isDepositDetailsAvailable = (this.sitecore.betslip.depositDetailsList || []).length > 0;
        this.depositInfo = this.trustPipe.transform(this.sitecore.betslip.messages.DepositInfoMessageOnConfirmation, 'html');
        this.picks = this.succeededSlips.flatMap((slip) => slip.picks);
        this.liveAlert =
            this.picks.filter((res: any) => res.clientPick.liveAlert === true && this.alertConfigService.isSportEnabled(res.clientPick.sportId))
                .length > 0;
    }

    onQuickLinkClicked(): void {
        this.store.dispatch(BetslipResultActions.close());
        this.store.dispatch(EditBetActions.requestDiscard());
    }

    showDeposit(): boolean {
        const showDepositEnabled = this.betslipConfig.isDepositOnBetslipConfirmationEnabled;

        return showDepositEnabled && this.showDepositOnConfirmation();
    }

    private showDepositOnConfirmation(): boolean {
        const currentDateTicks = new Date().setHours(0, 0, 0, 0);

        return this.picks.some((pick) => {
            const clientPick = pick.clientPick;
            if (clientPick && clientPick.isLive === false) {
                const startsAt = clientPick.eventDate.toISOString();

                const pickDateTicks = new Date(startsAt).setHours(0, 0, 0, 0);

                return currentDateTicks === pickDateTicks;
            }

            return false;
        });
    }

    async showDepositDetails(): Promise<void> {
        if (this.isDepositDetailsAvailable) {
            await this.modalDialogService.openDialog(DepositDetailsComponent);
        }
    }

    redirectToCashier(): void {
        this.cashierService.goToCashierDeposit({});
    }

    isNativeAlertEnabled(): boolean {
        return this.alertConfigService.isEnabled();
    }

    nativeAlertClicked(evt: Event): void {
        if (this.nativeAlertButton) {
            this.nativeAlertButton.clicked(evt);
        }
    }
}
